import { PredictionsLayoutOutlet } from "@/features/predictions/components/PredictionsLayoutOutlet";
import {
  PREDICTIONS_COMPETITION_DETAIL_PATH,
  PREDICTIONS_LEADERBOARD_PATH,
  PREDICTIONS_LOTS_PATH,
  PREDICTIONS_MATCHES_PATH,
  PREDICTIONS_PARTICIPANT_PATH,
  PREDICTIONS_PATH,
  PREDICTIONS_REGLEMENT_PATH,
  PREDICTIONS_SETTINGS_PATH,
  PREDICTIONS_STATS_PATH,
} from "@/features/predictions/constants/paths";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const CompetitionDetailPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/CompetitionDetailPage").then((m) => ({ default: m.CompetitionDetailPage })),
);
const LeaderboardPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/LeaderboardPage").then((m) => ({ default: m.LeaderboardPage })),
);
const LotsPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/LotsPage").then((m) => ({ default: m.LotsPage })),
);
const MyStatsPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/MyStatsPage").then((m) => ({ default: m.MyStatsPage })),
);
const ParticipantPredictionsPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/ParticipantPredictionsPage").then((m) => ({ default: m.ParticipantPredictionsPage })),
);
const PredictionsDashboardPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/PredictionsDashboardPage").then((m) => ({ default: m.PredictionsDashboardPage })),
);
const PredictionsMatchesPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/PredictionsMatchesPage").then((m) => ({ default: m.PredictionsMatchesPage })),
);
const PredictionsSettingsPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/PredictionsSettingsPage").then((m) => ({ default: m.PredictionsSettingsPage })),
);
const ReglementPage = lazyWithRetry(() =>
  import("@/features/predictions/pages/ReglementPage").then((m) => ({ default: m.ReglementPage })),
);

export {
  PREDICTIONS_PATH,
  PREDICTIONS_MATCHES_PATH,
  PREDICTIONS_LEADERBOARD_PATH,
  PREDICTIONS_LOTS_PATH,
  PREDICTIONS_STATS_PATH,
  PREDICTIONS_SETTINGS_PATH,
  PREDICTIONS_REGLEMENT_PATH,
  PREDICTIONS_COMPETITION_DETAIL_PATH,
  PREDICTIONS_PARTICIPANT_PATH,
} from "@/features/predictions/constants/paths";

const stripParent = (absolutePath: string): string =>
  absolutePath.startsWith(`${PREDICTIONS_PATH}/`)
    ? absolutePath.slice(PREDICTIONS_PATH.length + 1)
    : absolutePath;

const predictionsRoutes: RouteConfig[] = [
  {
    path: PREDICTIONS_PATH,
    element: <PredictionsLayoutOutlet />,
    isProtected: true,
    useMainLayout: true,
    children: [
      {
        index: true,
        element: <PredictionsDashboardPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_MATCHES_PATH),
        element: <PredictionsMatchesPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_LEADERBOARD_PATH),
        element: <LeaderboardPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_LOTS_PATH),
        element: <LotsPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_STATS_PATH),
        element: <MyStatsPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_SETTINGS_PATH),
        element: <PredictionsSettingsPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_REGLEMENT_PATH),
        element: <ReglementPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_COMPETITION_DETAIL_PATH),
        element: <CompetitionDetailPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(PREDICTIONS_PARTICIPANT_PATH),
        element: <ParticipantPredictionsPage />,
        isProtected: false,
        useMainLayout: false,
      },
    ],
  },
];

export default predictionsRoutes;
